import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "itemsContainer",
    "subtotal",
    "tax",
    "shipping",
    "total",
    "taxRate",
    "itemTemplate",
  ];

  connect() {
    console.log("Purchase order form controller connected");
    this.updateInitialTotals();
    this.updateTotalOrder();
    // Écouter l'événement
    this.boundUpdateTotalOrder = this.updateTotalOrder.bind(this);
    document.addEventListener(
      "purchase_order_item:updateTotalOrder",
      this.boundUpdateTotalOrder
    );
  }

  disconnect() {
    // Nettoyer l'écouteur d'événement
    document.removeEventListener(
      "purchase_order_item:updateTotalOrder",
      this.boundUpdateTotalOrder
    );
  }

  updateInitialTotals() {
    // Calculate totals for each existing item on page load
    const items = this.itemsContainerTarget.querySelectorAll(
      "[data-controller='purchase-order-item']"
    );
    items.forEach((item) => {
      const event = new CustomEvent("calculate-item");
      item.dispatchEvent(event);
    });
  }

  calculateTotals() {
    const subtotal = this.calculateSubtotal();
    const taxRate = parseFloat(this.taxRateTarget.value || 0);
    const shipping = parseFloat(this.shippingTarget.value || 0);

    const taxAmount = subtotal * (taxRate / 100);
    const total = subtotal + taxAmount + shipping;

    this.subtotalTarget.textContent = this.formatCurrency(subtotal);
    this.taxTarget.textContent = this.formatCurrency(taxAmount);
    this.totalTarget.textContent = this.formatCurrency(total);
  }

  calculateSubtotal() {
    const itemControllers =
      this.application.getControllerForElementAndIdentifier(
        this.itemsContainerTarget,
        "purchase-order-items"
      );

    if (itemControllers) {
      return itemControllers.calculateSubtotal();
    }

    // Fallback calculation by collecting from individual items
    let subtotal = 0;
    const itemElements = this.itemsContainerTarget.querySelectorAll(
      '[data-controller="purchase-order-item"]'
    );

    itemElements.forEach((element) => {
      const itemController =
        this.application.getControllerForElementAndIdentifier(
          element,
          "purchase-order-item"
        );
      if (itemController) {
        subtotal += itemController.getItemTotal();
      }
    });

    return subtotal;
  }

  updateTotals() {
    this.calculateTotals();
  }

  addItem(event) {
    event.preventDefault();

    // Get the template content
    const template = this.itemTemplateTarget.innerHTML;

    // Create a new record ID (timestamp-based)
    const newRecordId = new Date().getTime();

    // Replace the placeholder with the new record ID
    const newItem = template.replace(/NEW_RECORD/g, newRecordId);

    // Add the new item to the container
    this.itemsContainerTarget.insertAdjacentHTML("beforeend", newItem);

    // Initialize the Stimulus controller for the new item
    const addedItem = this.itemsContainerTarget.lastElementChild;
    const customEvent = new CustomEvent("calculate-item");
    addedItem.dispatchEvent(customEvent);
  }

  updateTotalOrder() {
    // This method will be called by the item controller when an item is modified or removed
    let totalOrder = 0;

    // Get all item totals
    const items = this.itemsContainerTarget.querySelectorAll(
      "[data-purchase-order-item-target='total']"
    );
    items.forEach((item) => {
      // Parse the total value (remove the currency symbol and any formatting)
      const value = parseFloat(item.textContent.replace(/[^\d.-]/g, "")) || 0;
      totalOrder += value;
    });

    // If we have a total element for the whole order, update it
    const orderTotalElement = document.querySelector(
      "[data-purchase-order-form-target='orderTotal']"
    );
    if (orderTotalElement) {
      orderTotalElement.textContent = this.formatCurrency(totalOrder);
    }
  }

  formatCurrency(value) {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "XAF",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }
}
